"use strict";

exports.__esModule = true;
exports.RcPortal = RcPortal;

var _react = require("react");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactHooks = require("@okee-uikit/react-hooks");

var _reactUtils = require("@okee-uikit/react-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RcPortal(props) {
  var children = props.children,
      getContainer = props.getContainer,
      onUpdated = props.onUpdated;
  var prevParent = (0, _react.useRef)(null);
  var container = (0, _reactHooks.useSingleton)(function () {
    return document.createElement('div');
  });
  var parent = getContainer == null ? document.body : getContainer();
  var isEqual = (0, _reactUtils.equal)(prevParent.current, parent);
  prevParent.current = parent;

  if (!isEqual && parent) {
    parent.appendChild(container);
  }

  (0, _react.useEffect)(function () {
    return function () {
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (parent && onUpdated) {
      onUpdated();
    }
  });

  if (parent) {
    return _reactDom.default.createPortal(children, container);
  }

  return null;
}